import { MONTHS_NEAR_EXPIRATION_THRESHOLD } from '../../utils/constants';

/**
 * Return an array of IDs for the leases list
 *
 * @param state
 * @returns {*[]}
 */
export function leaseIds(state) {
  return state.leases.map((lease) => lease.id);
}

export function hasLeases(state) {
  return Boolean(Array.isArray(state.leases) && state.leases.length);
}

export function nearExpirationRegos(state) {
  return state.leases
    .filter(
      ({ currentMonth, term }) =>
        term - currentMonth <= MONTHS_NEAR_EXPIRATION_THRESHOLD
    )
    .map(({ id, vehicleRego }) => ({ id, vehicleRego }));
}

export function activeLeases(state) {
  return state.leases.filter((lease) => !!lease.leaseActive);
}

export function evVehicleLeases(state) {
  return state.leases.filter((lease) => lease.isEv === true);
}
